var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8907 1.03535C0.311794 1.21348 -0.0518779 1.78867 0.0408955 2.37871C0.126247 2.9168 0.523317 3.29902 1.08367 3.38066C1.39168 3.4252 17.6085 3.4252 17.9165 3.38066C18.2096 3.33613 18.436 3.22852 18.6253 3.03926C19.2005 2.46406 19.0446 1.51035 18.3136 1.1207L18.128 1.02051L9.55574 1.01309C4.84285 1.00938 0.942653 1.02051 0.8907 1.03535Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.835034 8.36074C0.489917 8.49805 0.193042 8.79121 0.0928467 9.09551C0.0112061 9.33301 0.0112061 9.66699 0.0928467 9.9082C0.170776 10.142 0.449097 10.4537 0.690307 10.5762L0.872143 10.6689H6.08601H11.2999L11.4743 10.5836C12.2165 10.2162 12.3872 9.21797 11.8009 8.65391C11.7192 8.56856 11.5708 8.46465 11.4743 8.41641L11.2999 8.33106L6.12312 8.32363C2.2155 8.31992 0.920385 8.32734 0.835034 8.36074Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05022 15.623C0.389673 15.7195 -0.0630615 16.3393 0.0408447 16.9998C0.10022 17.3672 0.341431 17.6975 0.686548 17.8793L0.872095 17.9795H9.50002H18.128L18.3135 17.8793C19.0446 17.4896 19.2004 16.5359 18.6252 15.9607C18.436 15.7715 18.2096 15.6639 17.9164 15.6193C17.6344 15.5822 1.32854 15.5822 1.05022 15.623Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.0051,
    y: 8.32277,
    width: 4.99488,
    height: 2.34618,
    rx: 1.17309,
    fill: "white",
    fillOpacity: 0.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.230a2211b5313821ec255ef1b11e624d.svg";
export { ForwardRef as ReactComponent };